import React, { useState } from "react";
import "./sidebar.css";
import DarkMode from "../../components/darkmode/DarkMode";

const Sidebar = () => {
  const [toggle, showMenu] = useState(false);
  return (
    <>
      <aside className={toggle ? "aside show-menu" : "aside"}>
        <a href="#home" className="nav___logo">
          <img
            src="/images/logo.svg"
            alt="Ivan Tsang Logo"
          />
        </a>

        <nav className="nav">
          <div className="nav__menu">
            <ul className="nav__list">
              <li className="nav__item">
                <a href="#home" className="nav__link">
                  <i className="fa-solid fa-house"></i>
                </a>
              </li>
              {/* <li className="nav__item">
                <a href="#about" className="nav__link">
                  <i className="fa-solid fa-address-card"></i>
                </a>
              </li> */}
              <li className="nav__item">
                <a href="#experience" className="nav__link">
                  <i className="fa-solid fa-graduation-cap"></i>
                </a>
              </li>

              <li className="nav__item">
                <a href="#portfolio" className="nav__link">
                  <i className="fa-solid fa-folder-open"></i>
                </a>
              </li>
              {/* <li className="nav__item">
                <a href="#contact" className="nav__link">
                  <i className="fa-solid fa-message"></i>
                </a>
              </li> */}
              <li className="nav__item">
                <DarkMode />
              </li>
            </ul>
          </div>
        </nav>

        <div className="nav_footer">
          <span className="copyright"></span>
        </div>
      </aside>

      <div
        className={toggle ? "nav__toggle nav__toggle-open" : "nav__toggle"}
        onClick={() => showMenu(!toggle)}
      >
        <i className="icon-menu"></i>
      </div>
    </>
  );
};

export default Sidebar;
